// src/components/pos/CloseCashDrawerModal.js
import React, { useState, useContext } from 'react';
import { Modal, Box, Typography, TextField, Button, Alert } from '@mui/material';
import api from '../../api/index.js';
import AuthContext from '../../context/AuthContext.js';

const style = { 
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600, // Ancho ajustado
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    maxHeight: '90vh',
    overflowY: 'auto' };

const CloseCashDrawerModal = ({ open, onClose }) => {
    const { checkCashSessionStatus } = useContext(AuthContext);
    const [closingBalance, setClosingBalance] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleCloseDrawer = async () => {
        if (!closingBalance || isNaN(parseFloat(closingBalance))) {
            setError('Debes introducir el monto total de efectivo contado.');
            return;
        }
        setLoading(true);
        setError('');
        try {
            await api.post('/cash-sessions/close', { closing_balance: parseFloat(closingBalance) });
            await checkCashSessionStatus(); // Actualiza el estado global de la caja
            onClose(); // Cierra el modal
        } catch (err) {
            setError(err.response?.data?.message || 'Error al cerrar la caja.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={style}>
                <Typography variant="h5" gutterBottom>Cerrar Caja y Realizar Corte</Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Introduce el monto total de efectivo que tienes en la caja para finalizar tu turno.
                </Typography>
                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                <TextField
                    margin="normal" required fullWidth autoFocus
                    label="Efectivo Contado" type="number"
                    value={closingBalance}
                    onChange={(e) => setClosingBalance(e.target.value)}
                />
                <Button
                    variant="contained" color="secondary" fullWidth sx={{ mt: 2 }}
                    onClick={handleCloseDrawer} disabled={loading}
                >
                    {loading ? 'Cerrando...' : 'Cerrar Caja'}
                </Button>
            </Box>
        </Modal>
    );
};

export default CloseCashDrawerModal;